export type Suppression = {
  created: number;
  email: string;
  reason: string;
  status: string;
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_CATEGORY = 'bounces';
export const DEFAULT_SEARCH = '';

export const PER_PAGE = 50;

export const CATEGORIES_MAP = {
  bounces: 'Bounced',
  spam_reports: 'Spammed',
};

export const CATEGORIES = Object.keys(CATEGORIES_MAP);
